/**
 * Pushes custom events to the GTM dataLayer so tags configured in the GTM
 * container — e.g. Google Ads conversions — can trigger on them. Mirrors
 * lib/analytics.ts: a thin, fire-and-forget shim that no-ops when GTM
 * isn't on the page (no GTM_ID set, e.g. local dev, or before the container
 * bootstraps). The dataLayer is created by the beforeInteractive bootstrap in
 * app/layout.tsx, so it exists by the time a React effect can fire one of these.
 *
 * The push itself is consent-neutral — it only appends an object to an array.
 * Whether the downstream tag sets cookies or sends ad-identified data is
 * governed by Google Consent Mode v2 (see lib/consent.ts and the bootstrap in
 * app/layout.tsx), not by this function.
 *
 * window.dataLayer is typed globally in lib/consent.ts.
 */
import { stripNullish } from "./analytics-props";

export const trackGtmEvent = (
  event: string,
  params?: Record<string, string | number | boolean | null | undefined>,
): void => {
  if (typeof window === "undefined") return;

  window.dataLayer?.push({ event, ...stripNullish(params) });
};
